import { getAccessToken, tryRefresh } from './api.js'

// Open an authenticated Server-Sent Events stream (§8.5) and call `onEvent` for each
// named event. Returns a handle with `.close()`. EventSource can't set an auth header,
// so the access token rides the query string; on any error we reconnect after a short
// backoff, refreshing the token first (EventSource's own retry would reuse the stale
// one). `path` is relative to /api (e.g. '/tickets/stream').
export function openEventStream(path, eventName, onEvent) {
  let es = null
  let timer = null
  let closed = false

  const cleanup = () => { if (es) { es.close(); es = null } }

  const scheduleReconnect = () => {
    if (closed || timer) return
    timer = setTimeout(async () => {
      timer = null
      if (closed) return
      await tryRefresh()   // best-effort; connect() uses whatever token we then have
      connect()
    }, 5000)
  }

  const connect = () => {
    if (closed) return
    const token = getAccessToken()
    if (!token) { scheduleReconnect(); return }
    const sep = path.includes('?') ? '&' : '?'
    es = new EventSource(`/api${path}${sep}token=${encodeURIComponent(token)}`)
    es.addEventListener(eventName, onEvent)
    es.onerror = () => { cleanup(); scheduleReconnect() }
  }

  connect()
  return {
    close() {
      closed = true
      cleanup()
      if (timer) { clearTimeout(timer); timer = null }
    }
  }
}
